import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Analytics from '@module/analytics';
import I18n from '@module/i18n';
import LaunchDarkly from '@module/launchdarkly';

import Button from '@component/form/element/button';

import Actions from '@app/action';
import { EXPERIMENT_COOKIE_BANNER_COPY } from '@app/constant/experiments';

export const CookiesNotice = ({
  acceptTrackers,
  declineTrackers,
  closePanel,
}) => {
  const cookieCopyVariant = LaunchDarkly.getVariant(
    EXPERIMENT_COOKIE_BANNER_COPY
  );

  useEffect(() => {
    Analytics.trackSnowplowEvent({
      category: 'cookie_banner',
      action: 'show_banner',
      label:
        cookieCopyVariant === 'none'
          ? 'experiment2_2020'
          : `experiment3${cookieCopyVariant}_2020`,
    });
  }, [cookieCopyVariant]);

  const handleAccept = () => {
    acceptTrackers();
    closePanel();

    Analytics.trackSnowplowEvent({
      category: 'cookie_banner',
      action: 'click_okay',
      label:
        cookieCopyVariant === 'none'
          ? 'experiment2_2020'
          : `experiment3${cookieCopyVariant}_2020`,
    });
  };

  const handleDecline = () => {
    declineTrackers();
    closePanel();

    Analytics.trackSnowplowEvent({
      category: 'cookie_banner',
      action: 'click_nope',
      label:
        cookieCopyVariant === 'none'
          ? 'experiment2_2020'
          : `experiment3${cookieCopyVariant}_2020`,
    });
  };

  const legalPageHref = '/legal/privacy?from_home';

  let cookieNotice = {
    title: {
      dangerouslySetInnerHTML: {
        __html: I18n.t('transfer.cookie-wall.title'),
      },
    },
    intro: {
      dangerouslySetInnerHTML: {
        __html: I18n.t('transfer.cookie-wall.intro', {
          href: legalPageHref,
        }),
      },
    },
    text: {
      dangerouslySetInnerHTML: {
        __html: I18n.t('transfer.cookie-wall.text', {
          href: legalPageHref,
        }),
      },
    },
    accept: I18n.t('transfer.cookie-wall.button-accept'),
    decline: I18n.t('transfer.cookie-wall.button-decline'),
  };

  switch (cookieCopyVariant) {
    case 'A': {
      cookieNotice = {
        title: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-A.title'),
          },
        },
        intro: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-A.intro', {
              href: legalPageHref,
            }),
          },
        },
        text: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-A.text', {
              href: legalPageHref,
            }),
          },
        },
        accept: I18n.t('transfer.cookie-wall.variant-A.button-accept'),
        decline: I18n.t('transfer.cookie-wall.variant-A.button-decline'),
      };
      break;
    }
    case 'B': {
      cookieNotice = {
        title: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-B.title'),
          },
        },
        intro: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-B.intro', {
              href: legalPageHref,
            }),
          },
        },
        text: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-B.text', {
              href: legalPageHref,
            }),
          },
        },
        accept: I18n.t('transfer.cookie-wall.variant-B.button-accept'),
        decline: I18n.t('transfer.cookie-wall.variant-B.button-decline'),
      };
      break;
    }
    case 'C': {
      cookieNotice = {
        title: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-C.title'),
          },
        },
        intro: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-C.intro', {
              href: legalPageHref,
            }),
          },
        },
        text: {
          dangerouslySetInnerHTML: {
            __html: I18n.t('transfer.cookie-wall.variant-C.text', {
              href: legalPageHref,
            }),
          },
        },
        accept: I18n.t('transfer.cookie-wall.variant-C.button-accept'),
        decline: I18n.t('transfer.cookie-wall.variant-C.button-decline'),
      };
      break;
    }
  }

  return (
    <div className="welcome__cookie-notice">
      <div className="welcome__cookie-notice-title" {...cookieNotice.title} />
      <div className="welcome__cookie-notice-intro" {...cookieNotice.intro} />
      <div className="welcome__cookie-notice-text" {...cookieNotice.text} />
      <div className="welcome__buttons">
        <Button
          text={cookieNotice.accept}
          className="welcome__button welcome__button--accept"
          onClick={handleAccept}
        />
        <Button
          text={cookieNotice.decline}
          className="welcome__button welcome__button--decline"
          onClick={handleDecline}
        />
      </div>
    </div>
  );
};

CookiesNotice.propTypes = {
  acceptTrackers: PropTypes.func.isRequired,
  declineTrackers: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
};

export const mapDispatchToProps = (dispatch) => ({
  acceptTrackers: () => {
    dispatch(Actions.Session.acceptTrackers());
  },
  declineTrackers: () => {
    dispatch(Actions.Session.declineTrackers());
  },
});

const ConnectedCookiesNotice = connect(null, mapDispatchToProps)(CookiesNotice);

ConnectedCookiesNotice.propTypes = {
  closePanel: PropTypes.func.isRequired,
};

export default ConnectedCookiesNotice;
